import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-left",
  "use": "arrow-left-usage",
  "viewBox": "0 0 9 14.95",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9 14.95\" id=\"arrow-left\"><path d=\"M8.55.45A1.52,1.52,0,0,0,6.4.44h0l-5.95,6a1.52,1.52,0,0,0,0,2.15h0l6,5.95a1.52,1.52,0,0,0,2.14-2.15L3.67,7.48,8.55,2.6a1.52,1.52,0,0,0,0-2.15h0\" transform=\"translate(0 0)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol